(() => {
    const searchComponents = document.querySelectorAll('[data-vd-component="search"]');
    if (searchComponents.length == 0) return;

    searchComponents.forEach((searchComponent) => {
        const toggleBtn = searchComponent.querySelector('[data-vd-action="toggle"]');
        const searchFormContainer = searchComponent.querySelector(".search-form-container");
        const searchFormHtml = searchFormContainer ? searchFormContainer.outerHTML : null;

        toggleBtn?.addEventListener("click", toggleModal);

        function toggleModal() {
            if (Vendallion?.PopupModal && searchFormHtml) {
                Vendallion.PopupModal({
                    content: searchFormHtml,
                    modalClass: `search-modal`,
                    onOpen: function (modal) {
                        bindEvents(modal);
                    },
                    onClose: function () {},
                });
            }
        }

        function loading(state) {
            if (state == true) {
                resultsContainer.classList.add("loading");
            } else {
                resultsContainer.classList.remove("loading");
            }
        }

        let resultsContainer = null;
        let culture = null;
        let query = null;
        let activeSearchRequestId = 0;

        function bindEvents(modal) {
            const input = modal.querySelector(".input-search");
            const autoSubmitLength = parseInt(input?.getAttribute("data-auto-submit-length")) || 2; // Minimum characters to trigger search
            resultsContainer = modal.querySelector(".results-container");
            culture = resultsContainer?.getAttribute("data-culture");

            input?.addEventListener(
                "input",
                debounce(async () => {
                    await submitSearch();
                }, 850),
            );

            async function submitSearch() {
                if (!resultsContainer) return;

                query = input.value;
                if (query.length >= autoSubmitLength) {
                    const requestId = ++activeSearchRequestId;
                    await renderResults(requestId, query);
                } else {
                    activeSearchRequestId++;
                    loading(false);
                    noResultsMessage(false);
                    resetVehicleResults();
                    resetArticleResults();
                }
            }
        }

        async function renderResults(requestId, queryTerm) {
            loading(true);

            const vehiclesResponse = await searchVenddalionAPI(queryTerm);
            if (!isLatestRequest(requestId)) return;

            const searchResponse = await searchProjectAPI(queryTerm);
            if (!isLatestRequest(requestId)) return;

            const vehiclesCount = vehiclesResponse?.hits?.total?.value || 0;
            const articlesCount = searchResponse?.count || 0;

            if (vehiclesCount === 0 && articlesCount === 0) {
                noResultsMessage(true);
            } else {
                noResultsMessage(false);
            }

            if (vehiclesCount > 0) {
                renderVehicleResults(vehiclesResponse, vehiclesCount, queryTerm);
            } else {
                resetVehicleResults();
            }

            if (articlesCount > 0) {
                renderArticleResults(searchResponse, articlesCount, queryTerm);
            } else {
                resetArticleResults();
            }
            if (isLatestRequest(requestId)) {
                loading(false);
            }
        }

        async function searchVenddalionAPI(queryTerm) {
            const url = `/engine/esqueryindex?hidefromsearch=1&lang=${culture}`;
            const data = {
                type: "products",
                query: queryTerm,
                path: "/",
                es_fields: "",
                es_geo_window: "",
            };

            return await fetch(url, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(data),
            })
                .then((res) => res.json())
                .catch((error) => {
                    console.error("Error fetching search results:", error);
                    return null;
                });
        }

        async function searchProjectAPI(queryTerm) {
            const url = "/api/queries/FullTextSearch";
            const data = {
                term: queryTerm,
                language: culture,
            };

            return await fetch(url, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(data),
            })
                .then((res) => res.json())
                .catch((error) => {
                    console.error("Error fetching search results:", error);
                    return null;
                });
        }

        function isLatestRequest(requestId) {
            return requestId === activeSearchRequestId;
        }

        function renderVehicleResults(response, count, queryTerm) {
            const vehiclesCount = count;
            const vehiclesResultsRow = resultsContainer.querySelector(".results-row.vehicles");

            const showAllBtnUrl = `/${culture}/inventory/search-products/?search-for=${encodeURIComponent(queryTerm)}`; // URL for showing all vehicles, can be dynamic based on the search query

            const tVehicle = resultsContainer.getAttribute("data-t-vehicle");
            const tVehicles = resultsContainer.getAttribute("data-t-vehicles");
            const tShowAll = resultsContainer.getAttribute("data-t-show-all");

            const vehiclesRowContent = `            
                <span class="result-count">${vehiclesCount} ${vehiclesCount === 1 ? tVehicle : tVehicles}</span>
                <a href="${showAllBtnUrl}" class="show-all-btn btn fourth">${tShowAll} ${tVehicles}</a>            
            `;

            if (vehiclesResultsRow) {
                vehiclesResultsRow.innerHTML = vehiclesRowContent;
            }
        }

        function resetVehicleResults() {
            const vehiclesResultsRow = resultsContainer.querySelector(".results-row.vehicles");
            if (vehiclesResultsRow) {
                vehiclesResultsRow.innerHTML = "";
            }
        }

        function renderArticleResults(response, count, queryTerm) {
            const resultsCount = count;
            const listContainer = resultsContainer.querySelector(".article-list");
            const articlesResultsRow = resultsContainer.querySelector(".results-row.articles");

            // Render the first 5 articles
            const tViewMore = resultsContainer.getAttribute("data-t-view-more");

            const articles = response?.items || [];
            let articlesListHtml = "";

            for (let i = 0; i < 5; i++) {
                if (i >= articles.length) {
                    break;
                }

                const article = articles[i];
                const articleTitle = article["Content.ContentItem.DisplayText.keyword"] || "";
                const articleUrl = article.AutoroutePart || "#";

                const articleHtml = `
                    <a class="article-item" href="${articleUrl}">
                        <span class="title">${articleTitle}</span>
                        <span class="link">${tViewMore}</span>
                    </a>`;

                articlesListHtml += articleHtml;
            }

            // Render article results count and "Show All" button
            if (listContainer) {
                listContainer.innerHTML = articlesListHtml;
            }

            const tArticle = resultsContainer.getAttribute("data-t-article");
            const tArticles = resultsContainer.getAttribute("data-t-articles");
            const tShowAll = resultsContainer.getAttribute("data-t-show-all");
            const showAllBtnUrl = `/search?Terms=${encodeURIComponent(queryTerm)}`;

            const articlesRow = `
                <span class="result-count">${resultsCount} ${resultsCount === 1 ? tArticle : tArticles}</span>
                <a href="${showAllBtnUrl}" class="show-all-btn btn fourth">${tShowAll} ${tArticles}</a>            
            `;

            if (articlesResultsRow) {
                articlesResultsRow.innerHTML = articlesRow;
            }
        }

        function resetArticleResults() {
            const listContainer = resultsContainer.querySelector(".article-list");
            const articlesResultsRow = resultsContainer.querySelector(".results-row.articles");
            if (listContainer) {
                listContainer.innerHTML = "";
            }
            if (articlesResultsRow) {
                articlesResultsRow.innerHTML = "";
            }
        }

        function noResultsMessage(state) {
            const noResultsContainer = resultsContainer.querySelector(".no-results");
            if (state) {
                noResultsContainer?.classList.add("visible");
            } else {
                noResultsContainer?.classList.remove("visible");
            }
        }
    });

    function debounce(callback, delay) {
        let timeoutId;

        return function (...args) {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => callback.apply(this, args), delay || 300);
        };
    }
})();
